import { Link } from "react-router-dom";

/**
 * Centralized RankTrust logo. Uses a single transparent-background PNG that
 * renders correctly on both dark and light surfaces — no blend modes needed.
 * Replace one place to rebrand the whole app.
 */
const LOGO_SRC = "/ranktrust-logo.png";

export default function RankTrustLogo({
  height = 36,
  tagline = false,
  taglineColor = "#4B5563",
  asLink = false,
}) {
  const content = (
    <div style={{ display: "inline-block" }}>
      <img
        src={LOGO_SRC + "?v=5"}
        alt="RankTrust.io"
        style={{ height, width: "auto", display: "block" }}
      />
      {tagline && (
        <div
          style={{
            fontSize: 10,
            letterSpacing: "1.5px",
            color: taglineColor,
            fontWeight: 700,
            textTransform: "uppercase",
            marginTop: 4,
            whiteSpace: "nowrap",
          }}
        >
          The Business Growth Intelligence Platform
        </div>
      )}
    </div>
  );

  if (asLink) {
    return (
      <Link to="/" data-testid="ranktrust-logo">
        {content}
      </Link>
    );
  }
  return content;
}
